import React, { memo } from 'react';

const ImportsAltIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M1.778 28.444h28.444c0.982 0 1.778 0.796 1.778 1.778s-0.796 1.778-1.778 1.778h-28.444c-0.982 0-1.778-0.796-1.778-1.778s0.796-1.778 1.778-1.778zM7.111 0c0.982 0 1.778 0.796 1.778 1.778l-0.002 17.029 2.287-2.286c0.694-0.694 1.82-0.694 2.514 0s0.694 1.82 0 2.514l-5.028 5.028-0.127 0.115c-0.324 0.432-0.841 0.711-1.422 0.711-0.569 0-1.075-0.267-1.401-0.683l-0.161-0.143-5.028-5.028c-0.694-0.694-0.694-1.82 0-2.514s1.82-0.694 2.514 0l2.297 2.297 0.002-17.040c0-0.982 0.796-1.778 1.778-1.778zM24.889 24.889c0.982 0 1.778-0.796 1.778-1.778l-0.002-17.029 2.287 2.286c0.694 0.694 1.82 0.694 2.514 0s0.694-1.82 0-2.514l-5.028-5.028-0.127-0.115c-0.324-0.432-0.841-0.711-1.422-0.711-0.569 0-1.075 0.267-1.401 0.683l-0.161 0.143-5.028 5.028c-0.694 0.694-0.694 1.82 0 2.514s1.82 0.694 2.514 0l2.297-2.297 0.002 17.040c0 0.982 0.796 1.778 1.778 1.778z"
        />
    </svg>
);

export default memo(ImportsAltIcon);
